import React from 'react'
import { Link } from 'react-router-dom'
import type { Blog, RouteDef } from '@ztechapps/common.contract'
import type { RowProps } from '@ztechapps/webui.data-tools'
import { WebuiIocKey, useInject } from '@ztechapps/webui.contract'
import { LocalDateTime } from '@ztechapps/webui.date'
import { Row, Table } from '@ztechapps/webui.data-tools'
import { DragHandle, HorizontalStack } from '@ztechapps/webui.util'
import { BlogStatus } from '../../BlogStatus'
import { getBlogMoveExcludedIds } from '../../BlogCategory/blogCategoryTree.utils'
import { NO_EDIT_PERMISSION_REASON } from '../../PermissionReasons'
import { useBlogCategoryTreeViewContext } from './Context'
import { MoveToMenu } from './MoveToMenu'
import { DragSourceKindEnum } from './useBlogCategoryDragDrop'
import styles from './BlogCategoryTreeView.module.scss'

const BlogRow = (props: RowProps<Blog>) => {
  const { _id, title, status, updatedAt, category } = props
  const blogItemRoute = useInject<RouteDef>(WebuiIocKey.routes.blogItem)
  const { canEdit, moveBlog, getDragSourceProps } = useBlogCategoryTreeViewContext()
  const excludedBlogCategoryIds = getBlogMoveExcludedIds({ category })

  return (
    <Row {...props}>
      <td>
        <HorizontalStack gap={2}>
          <DragHandle
            title={canEdit ? 'Drag to move this blog' : NO_EDIT_PERMISSION_REASON}
            aria-label={`Drag ${title}`}
            disabled={!canEdit}
            hideTooltipOnDrag
            {...getDragSourceProps({ kind: DragSourceKindEnum.Blog, _id, excludedBlogCategoryIds })}
          />
          <Link to={blogItemRoute.altPath({ _id })}>{title}</Link>
        </HorizontalStack>
      </td>
      <td>
        <HorizontalStack gap={1}>
          <BlogStatus value={status} />
          <div>{status}</div>
        </HorizontalStack>
      </td>
      <td>
        <LocalDateTime value={updatedAt} />
      </td>
      <td className="text-end">
        <MoveToMenu
          excludedBlogCategoryIds={excludedBlogCategoryIds}
          onMove={(categoryId) => moveBlog(_id, categoryId)}
        />
      </td>
    </Row>
  )
}

export const BlogCategoryBlogTable = () => {
  const { selectedBlogs } = useBlogCategoryTreeViewContext()

  return (
    <Table
      tableClassName={`table table-striped align-middle mb-0 ${styles.stickyHead}`}
      dataArray={selectedBlogs}
      row={BlogRow}
      head={
        <thead>
          <tr>
            <th>Title</th>
            <th style={{ width: '10rem' }}>Status</th>
            <th style={{ width: '14rem' }}>Updated</th>
            <th style={{ width: '9rem' }}>
              <span className="visually-hidden">Actions</span>
            </th>
          </tr>
        </thead>
      }
    />
  )
}
